/* ==========================================================
   GOFFIK custom behaviours
   - Entrance gate: plays once per browser session, skipped
     for users who prefer reduced motion (handled by the
     inline check in theme.liquid + CSS).
   ========================================================== */
(function () {
  'use strict';

  var gate = document.getElementById('goffik-gate');
  if (!gate) return;

  // In the theme editor: reveal the scene briefly, then open automatically
  // so it's visible/testable without ever blocking the editing surface.
  if (gate.classList.contains('goffik-gate--editor')) {
    window.setTimeout(function () {
      gate.classList.add('goffik-gate--open');
    }, 1200);
    return;
  }

  // The inline <head> script adds this class when the gate
  // has already been seen this session (or reduced motion).
  if (document.documentElement.classList.contains('goffik-gate-skip')) {
    gate.parentNode.removeChild(gate);
    return;
  }

  document.documentElement.classList.add('goffik-gate-lock');

  function openGate() {
    if (!gate || gate.classList.contains('goffik-gate--open')) return;
    gate.classList.add('goffik-gate--open');
    try {
      sessionStorage.setItem('goffikGateSeen', '1');
    } catch (e) {
      /* private browsing — fail silently */
    }
    window.setTimeout(function () {
      if (gate && gate.parentNode) gate.parentNode.removeChild(gate);
      document.documentElement.classList.remove('goffik-gate-lock');
      gate = null;
    }, 1750);
  }

  // Open shortly after the page has finished loading…
  if (document.readyState === 'complete') {
    window.setTimeout(openGate, 1350);
  } else {
    window.addEventListener('load', function () {
      window.setTimeout(openGate, 1350);
    });
  }

  // …but never trap the visitor if 'load' is slow (safety net).
  window.setTimeout(openGate, 4000);
})();

/* ==========================================================
   Button burst FX — bats + smoky mist fly out on hover.
   Every burst is randomised (count, size, angle, distance,
   spin, speed, delay) so no two feel the same.
   ========================================================== */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var BAT_SVG =
    '<svg viewBox="0 0 100 56" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M44 22 C32 8 14 8 3 20 C12 18 16 23 17 28 C24 23 28 27 29 33 C34 28 40 30 44 35 Z"/>' +
    '<path d="M56 22 C68 8 86 8 97 20 C88 18 84 23 83 28 C76 23 72 27 71 33 C66 28 60 30 56 35 Z"/>' +
    '<path d="M43 16 L39 5 L47 12 Z"/><path d="M57 16 L61 5 L53 12 Z"/>' +
    '<ellipse cx="50" cy="26" rx="8" ry="13"/></svg>';

  var live = 0;
  var MAX_LIVE = 36;

  function rnd(min, max) {
    return Math.random() * (max - min) + min;
  }

  function spawnBat(rect) {
    if (live >= MAX_LIVE) return;
    var el = document.createElement('span');
    el.className = 'goffik-fx-bat';
    el.innerHTML = BAT_SVG;
    var size = rnd(14, 26);
    el.style.width = size + 'px';
    el.style.left = rect.left + rnd(0.1, 0.9) * rect.width + 'px';
    el.style.top = rect.top + rnd(0, 0.4) * rect.height + 'px';
    el.style.opacity = '0';
    el.style.transform = 'translate(-50%, -50%)';
    document.body.appendChild(el);
    live++;

    var tx = rnd(-90, 90);
    var ty = -rnd(60, 140);
    var rot = rnd(-40, 40);
    var anim = el.animate(
      [
        { transform: 'translate(-50%,-50%) translate(0,0) rotate(0deg) scale(0.6)', opacity: 0 },
        { transform: 'translate(-50%,-50%) translate(' + tx * 0.35 + 'px,' + ty * 0.45 + 'px) rotate(' + rot * 0.6 + 'deg) scale(1)', opacity: 1, offset: 0.3 },
        { transform: 'translate(-50%,-50%) translate(' + tx + 'px,' + ty + 'px) rotate(' + rot + 'deg) scale(0.9)', opacity: 0 }
      ],
      { duration: rnd(800, 1500), delay: rnd(0, 180), easing: 'cubic-bezier(.3,.6,.4,1)', fill: 'forwards' }
    );
    anim.onfinish = function () {
      el.remove();
      live--;
    };
  }

  function spawnPuff(rect) {
    if (live >= MAX_LIVE) return;
    var el = document.createElement('span');
    el.className = 'goffik-fx-puff';
    var size = rnd(26, 54);
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.left = rect.left + rnd(0.05, 0.95) * rect.width + 'px';
    el.style.top = rect.top + rnd(0.2, 0.8) * rect.height + 'px';
    el.style.opacity = '0';
    el.style.transform = 'translate(-50%, -50%)';
    document.body.appendChild(el);
    live++;

    var tx = rnd(-30, 30);
    var ty = -rnd(30, 80);
    var anim = el.animate(
      [
        { transform: 'translate(-50%,-50%) translate(0,0) scale(0.4)', opacity: 0 },
        { opacity: 0.55, offset: 0.25 },
        { transform: 'translate(-50%,-50%) translate(' + tx + 'px,' + ty + 'px) scale(1.6)', opacity: 0 }
      ],
      { duration: rnd(900, 1600), delay: rnd(0, 150), easing: 'ease-out', fill: 'forwards' }
    );
    anim.onfinish = function () {
      el.remove();
      live--;
    };
  }

  function burst(btn) {
    if (document.hidden) return;
    var rect = btn.getBoundingClientRect();
    var bats = Math.round(rnd(3, 5));
    var puffs = Math.round(rnd(3, 4));
    for (var i = 0; i < bats; i++) spawnBat(rect);
    for (var j = 0; j < puffs; j++) spawnPuff(rect);
  }

  var lastBurst = new WeakMap();
  // Guard against double-binding if the script is evaluated more than once
  // (Shopify's theme editor can re-inject scripts when sections reload).
  if (!window.__goffikBurstBound) {
    window.__goffikBurstBound = true;
    document.addEventListener(
      'mouseover',
      function (e) {
        var btn = e.target.closest ? e.target.closest('.button, button, .shopify-payment-button__button, [role="button"]') : null;
        if (!btn || btn.disabled) return;
        var now = Date.now();
        if (now - (lastBurst.get(btn) || 0) < 650) return;
        lastBurst.set(btn, now);
        burst(btn);
      },
      { passive: true }
    );
  }
})();
